<template>
  <!-- 成绩管理 弹窗：导出成绩 -->
    <el-dialog :title="exportTextConfig.title" v-loading="exporting" element-loading-text="请稍后"
               element-loading-spinner="el-icon-loading" v-if="dialogVisible" :visible.sync="dialogVisible"
               width="500px" @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
        <p class="flex"><span>{{ exportTextConfig.examPlan }}：</span><span>{{ row.examPlanName }}</span></p>
        <p class="flex"><span>{{ exportTextConfig.subject }}：</span><span>{{ row.subject }}</span></p>
        <p class="flex"><span>{{ exportTextConfig.examPaperName }}：</span><span>{{ row.examPaperName }}</span></p>
        <el-descriptions v-hasPermi="['review:survey']" :column="1" border v-loading="loading"
                         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <el-descriptions-item :label="tableConfig.reviewed">
                {{ tableConfig.countFormatter.signMix(data.reviewed) }}
            </el-descriptions-item>
            <el-descriptions-item :label="tableConfig.missExam">
                {{ tableConfig.countFormatter.signMix(data.missExam) }}
            </el-descriptions-item>
            <el-descriptions-item :label="tableConfig.invalidScore">
                {{ tableConfig.countFormatter.signMix(data.invalidScore) }}
            </el-descriptions-item>
            <el-descriptions-item :label="tableConfig.cheat">
                {{ tableConfig.countFormatter.signMix(data.cheat) }}
            </el-descriptions-item>
            <el-descriptions-item :label="tableConfig.total" :contentStyle="{'background': '#fafafa'}">
                {{ tableConfig.countFormatter.signMix(data.total) }}
            </el-descriptions-item>
        </el-descriptions>
        <el-checkbox-group v-model="exportType">
            <el-checkbox label="total">{{ checkBoxConfig.total }}</el-checkbox>
            <el-checkbox label="detailed">{{ checkBoxConfig.detailed }}</el-checkbox>
        </el-checkbox-group>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">{{ buttonConfig.cancel }}</el-button>
            <el-button v-hasPermi="['review:plan:export']" type="primary" @click="submitForm()"
                       :disabled="loading">{{ buttonConfig.ok }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: ['row', 'show'],
    data() {
        return {
            dialogVisible: false,
            loading: true,
            exporting: false,
            data: {
                reviewed: 0,
                missExam: 0,
                invalidScore: 0,
                cheat: 0,
                notReviewed: 0,
                total: 0
            },
            radio: 0,
            exportType: ['total'],
        };
    },
    computed: {
        exportTextConfig() {
            return this.$store.state.global.textConfig.backend.achievement.table.button.export
        },
        tableConfig() {
            return this.exportTextConfig.table
        },
        checkBoxConfig() {
            return this.exportTextConfig.checkBox
        },
        buttonConfig() {
            return this.exportTextConfig.button
        }
    },
    watch: {
        show() {
            this.loading = true
            this.dialogVisible = this.show;
            if (this.show) {
                this.getData()
            }
        },
    },
    methods: {
        getData() {
            this.$store.dispatch('getReviewData', {
                examId: this.row.id,
                examPaperId: this.row.examPaperId
            }).then(res => {
                if (res.status === 200) {
                    this.loading = false
                    this.data = res.data
                }
            })
        },
        close() {
            this.dialogVisible = false
            this.exporting = false
            this.$emit('close', false)
        },
        download(filename, resData) {
            let a = document.createElement('a')
            let url = `${this.config_env.BASE_URL}/api/review/plan/export_score/download/${resData}/${filename}`
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
            this.$message({type: 'success', message: filename + '导出成功'})
        },
        submitForm() {
            let examId = this.row.id
            let examPlan = this.row.examPlanName
            if (this.exportType.length) {
                this.exporting = true
                if (this.exportType.includes('total')) {
                    this.$store.dispatch('getExportScore', {
                        examId: examId,
                        examPaperId: this.row.examPaperId
                    }).then(res => {
                        if (res.status === 200) {
                            let filename = examPlan + '-成绩单'
                            this.download(filename, res.data)
                        }
                    })
                }
                if (this.exportType.includes('detailed')) {
                    this.$store.dispatch('getDetailScore', {
                        examId: examId,
                        examPaperId: this.row.examPaperId
                    }).then(res => {
                        if (res.status === 200) {
                            let filename = examPlan + '-详细成绩单'
                            this.download(filename, res.data)
                        }
                    })
                }
                this.close()
            } else {
                this.$message({type: 'warning', message: '请至少选择一种导出方案'});
            }
        },
    }
};
</script>

<style scoped>
.flex {
    display: flex;
}

.flex span:first-child {
    width: 70px;
}

.flex span:last-child {
    width: calc(100% - 70px);
}
</style>